import { FactType } from '@/api/rest/resources/conservation';
import { useFact } from '@/pages/shared/projects/pages/project/pages/conservation/shared/hooks/useFact';

export const useLegendRange = (factName: FactType, legendLength = 6): number[] | undefined => {
  const dataRange: [number, number] = useFact<[number, number]>(factName)?.value;

  if (!dataRange) {
    return undefined;
  }

  return new Array(legendLength).fill(0).map((_, index) => {
    const step = (dataRange[1] - dataRange[0]) / (legendLength - 1);
    return dataRange[0] + step * index;
  });
};
